<template>
  <header :class="{ isBackground: isBackground }">
    <button @click="toggleMenu" class="hamburger-button">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <h1 class="logo-container">
      <a href="/" class="logo"><img src="/img/logo/black_je.png" alt="JAPAN EDITION"></a>
    </h1>
    <nav class="menu" :class="isMenuOpen ? 'isActive' : ''">
      <div class="bg-layer"></div>
      <button @click="toggleMenu" class="close-button"></button>
      <ul>
        <li v-for="menu in menus" :key="menu.label">
          <a :href="menu.link" :text="menu.label"></a>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMenuOpen: false,
      isBackground: false,
      menus: [
        {
          label: 'CONCEPT',
          link: '/concept/',
        },
        {
          label: 'SHOP',
          link: '/shop/',
        },
        {
          label: 'NEWS',
          link: '/news/',
        },
      ],
      newsSection: null,
      header: null,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    setTimeout(() => {
      this.handleBackgroundClass();
    }, 300);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleScroll() {
      this.handleBackgroundClass();
    },
    handleBackgroundClass() {
      this.newsSection = document.getElementById('bg-inversion');
      this.header = document.querySelector('header');

      if (this.newsSection && this.header) {
        const newsTop = this.newsSection.getBoundingClientRect().top;
        this.isBackground = newsTop <= this.header.offsetHeight;
      }
    },
  },
};
</script>

<style scoped lang="scss">
header {
  display: flex;
  align-items: center;
  width: 100vw;
  padding: 2em 1em;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  transition: background-color 0.3s;
  &.isBackground {
    background-color: rgba(white, .8);
  }
}

.logo-container {
  flex: 1;
  display: flex;;
  justify-content: center;
  a, img {
    display: block;;
  }
}
.logo {
  max-width: 100%;
  height: auto;
  width: 45vw;
  max-width: 250px;
  margin-left: -24px;
}

.hamburger-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 24px;
  padding: 0;
  span {
    display: block;
    height: 2px;
    background-color: black;
    border-radius: 2px;
    transition: all 0.3s ease;
    &:nth-child(1) {
      width: 20px;
    }
    &:nth-child(2) {
      width: 24px;
    }
    &:nth-child(3) {
      width: 16px;
    }
  }
}

.menu {
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  max-width: 800px;
  .bg-layer {
    width: 100%;
    height: 100vh;
    background-color: rgba(black, .3);
    position: absolute;
    left: 0;
    z-index: 0;
    padding: 0 24px 0 12px;
  }
  ul {
    width: 80%;
    height: 100vh;
    position: relative;
    z-index: 1;
    background-color: white;
    margin-left: 3%;
    padding: 24px;
  }
  li {
    border-top: 1px solid #ccc;
    &:last-child {
      border-bottom: 1px solid #ccc;
    }
  }
  a {
    display: block;
    padding: 2em 1em;
  }
  &.isActive {
    transform: translateX(0);
  }
}

.close-button {
  $size: 36px;
  position: absolute;
  top: ($size / 2);
  right: ($size / 2);
  width: $size;
  height: $size;
  background: none;
  border: none;
  cursor: pointer;
  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: $size;
    height: 1px;
    background-color: white;
  }
  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}

@media screen and (min-width: 768px) {
  .menu {
    ul {
      width: 88%;
    }
  }
}

@media screen and (min-width: 1024px) {
}
</style>
